import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NetworkDiagramSelectionHelperService {

  getShapeSelection(diagram, data): any {
    const selectedNodes = diagram.getSelectedNodes();

    const selectedNodesToReturn = [];

    selectedNodes.forEach((nodeId) => {
      if (diagram.isCluster(nodeId)) {
        const currentCluster = data.clusters.find((c) => {
          return c.id === nodeId;
        });
        selectedNodesToReturn.push({
          shapeType: 'cluster',
          id: nodeId,
          nodes: data.nodes.get(currentCluster.nodes),
          name: currentCluster.name
        });
      } else {
        selectedNodesToReturn.push(data.nodes.get(nodeId));
      }
    });

    return selectedNodesToReturn;
  }

  getConnectionSelection(diagram, data): any {
    const selectedEdges = diagram.getSelectedEdges();

    const selectedEdgesToReturn = [];

    selectedEdges.forEach((edgeId) => {
      if (edgeId.indexOf('clusterEdge') > -1) {
        selectedEdgesToReturn.push({connectionType: 'cluster', id: edgeId, edges: data.edges.get(diagram.clustering.getBaseEdges(edgeId))});
      } else {
        selectedEdgesToReturn.push(data.edges.get(edgeId));
      }
    });

    return selectedEdgesToReturn;
  }
}
